import { Icon } from '@shared/components/Icon';
import { Menu } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useMonthOptions } from './hooks/useMonthOptions';

export function MonthOptions({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const {
    dateSelectOptions,
    nthSelectOptions,
    daySelectOptions,
    handleDayOfMonthSelect,
    handleFullNthSelect,
    isDayOfMonthSelected,
    isNthWeekdaySelected,
    dayOfMonthDisplay,
    nthDayDisplay,
    nthDayWeekdayDisplay,
  } = useMonthOptions({ rruleOptions, setRruleOptions });

  return (
    <View gap={1}>
      <Text size="body1" weight="semibold">
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </Text>
      <View row centerVertically gap={1}>
        <ButtonView
          role="radio"
          aria-checked={isDayOfMonthSelected}
          onClick={handleDayOfMonthSelect}
        >
          {isDayOfMonthSelected && (
            <Icon color={Colors.v2.green} name="radio-button" gridSize={4} />
          )}

          {!isDayOfMonthSelected && (
            <Icon color={Colors.v2.green} name="unfilled-circle" gridSize={4} />
          )}
        </ButtonView>
        <Menu>
          <Menu.Button flex label={dayOfMonthDisplay} />
          <Menu.Content>
            <Menu.Options
              options={dateSelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
      </View>
      <View row centerVertically gap={1}>
        <ButtonView role="radio" aria-checked={isNthWeekdaySelected} onClick={handleFullNthSelect}>
          {isNthWeekdaySelected && (
            <Icon color={Colors.v2.green} name="radio-button" gridSize={4} />
          )}
          {!isNthWeekdaySelected && (
            <Icon color={Colors.v2.green} name="unfilled-circle" gridSize={4} />
          )}
        </ButtonView>
        <Menu>
          <Menu.Button label={nthDayDisplay} />
          <Menu.Content>
            <Menu.Options
              options={nthSelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
        <Menu>
          <Menu.Button flex label={nthDayWeekdayDisplay} />
          <Menu.Content>
            <Menu.Options
              options={daySelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
      </View>
    </View>
  );
}
